export default "__VITE_ASSET__CYrRm6rq__"